import { useMutation, useQueryClient } from "@tanstack/react-query";
import { mergeDuplicateUsers, MergeGroup } from "../services/merge-duplicate-users";
import { useToast } from "@/hooks/use-toast";

export function useMergeDuplicateUsers() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (groups: MergeGroup[]) => mergeDuplicateUsers(groups),
    onSuccess: (data) => {
      toast({
        title: "Merge complete",
        description: `${data.merged} group${data.merged !== 1 ? "s" : ""} merged successfully.`,
      });
      queryClient.invalidateQueries({ queryKey: ["users"] });
      queryClient.invalidateQueries({ queryKey: ["duplicate-identifiers"] });
    },
    onError: () => {
      toast({
        title: "Merge failed",
        description: "Something went wrong. Please try again.",
        variant: "destructive",
      });
    },
  });
}
